// src/components/usuarios/UsuariosMain.js
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs';
import {
    useToast,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
    useDisclosure,
} from '@chakra-ui/react';

/* ---- Ícones SVG ---- */
const ArrowLeftIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
    </svg>
);
const UsersIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
);
const PlusIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
    </svg>
);
const EditIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
);
const DeleteIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
);
const RepeatIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
        <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
);
const LogoutIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" />
    </svg>
);
const ChevronIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);
const HomeIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
    </svg>
);
const EyeIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
    </svg>
);
const EyeOffIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
);

const PERFIS_ACESSO = [
    { value: 'admin',       label: 'Administrador', description: 'Acesso total', color: '#ef4444', bg: 'rgba(239,68,68,0.08)',    border: 'rgba(239,68,68,0.2)',    modulos: ['Cadastro', 'Diretor', 'Operacional', 'Palestrante', 'Relatórios', 'Usuários'] },
    { value: 'diretor',     label: 'Diretor',       description: 'Visão estratégica', color: '#7c3aed', bg: 'rgba(124,58,237,0.08)',  border: 'rgba(124,58,237,0.2)',   modulos: ['Cadastro', 'Diretor', 'Relatórios'] },
    { value: 'operacional', label: 'Operacional',   description: 'Acompanhamento operacional', color: '#2563eb', bg: 'rgba(37,99,235,0.08)', border: 'rgba(37,99,235,0.2)', modulos: ['Operacional'] },
    { value: 'palestrante', label: 'Palestrante',   description: 'Visão do apresentador', color: '#ea580c', bg: 'rgba(234,88,12,0.08)', border: 'rgba(234,88,12,0.2)',  modulos: ['Palestrante'] },
];

const getPerfilInfo = (v) => PERFIS_ACESSO.find(p => p.value === v) || PERFIS_ACESSO[0];
const getInitials = (name) => name ? name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase() : '?';

const UsuariosMain = ({ supabase, session, clienteData, onLogout }) => {
    const navigate = useNavigate();
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();

    const [usuarios, setUsuarios] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [usuarioEditando, setUsuarioEditando] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [showSenha, setShowSenha] = useState(false);

    const [formData, setFormData] = useState({ nome: '', email: '', senha: '', perfil: 'operacional', ativo: true });

    const nomeUsuario = session?.user?.user_metadata?.nome || 'Usuário';
    const iniciais = nomeUsuario.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();

    const handleLogout = async () => {
        try { await onLogout(); } catch (e) { console.error(e); }
    };

    const fetchUsuarios = useCallback(async () => {
        setIsLoading(true);
        try {
            const clienteId = session.user.user_metadata?.cliente_id || session.user.app_metadata?.cliente_id || clienteData?.id;
            if (!clienteId) throw new Error('Cliente ID não encontrado');
            const { data, error } = await supabase.from('usuarios_sistema').select('*').eq('cliente_id', clienteId).order('created_at', { ascending: false });
            if (error) throw error;
            setUsuarios(data || []);
        } catch (error) {
            toast({ title: 'Erro ao carregar usuários', description: error.message, status: 'error', duration: 5000, isClosable: true });
        } finally {
            setIsLoading(false);
        }
    }, [supabase, session, clienteData, toast]);

    useEffect(() => { fetchUsuarios(); }, [fetchUsuarios]);

    useEffect(() => {
        if (!menuOpen) return;
        const close = () => setMenuOpen(false);
        document.addEventListener('click', close);
        return () => document.removeEventListener('click', close);
    }, [menuOpen]);

    const handleNovoUsuario = () => {
        setUsuarioEditando(null);
        setFormData({ nome: '', email: '', senha: '', perfil: 'operacional', ativo: true });
        onOpen();
    };

    const handleEditarUsuario = (u) => {
        setUsuarioEditando(u);
        setFormData({ nome: u.nome, email: u.email, senha: '', perfil: u.perfil, ativo: u.ativo });
        onOpen();
    };

    const handleSalvarUsuario = async () => {
        if (!formData.nome || !formData.email || !formData.perfil) {
            toast({ title: 'Campos obrigatórios', description: 'Preencha todos os campos.', status: 'warning', duration: 3000, isClosable: true });
            return;
        }
        if (!usuarioEditando && !formData.senha) {
            toast({ title: 'Senha obrigatória', status: 'warning', duration: 3000, isClosable: true });
            return;
        }
        const emailJaExiste = usuarios.some(u => u.email.toLowerCase() === formData.email.toLowerCase() && u.id !== usuarioEditando?.id);
        if (emailJaExiste) {
            toast({ title: 'Email já cadastrado', description: 'Já existe um usuário com esse endereço de e-mail.', status: 'warning', duration: 4000, isClosable: true });
            return;
        }
        setIsSaving(true);
        try {
            const { data: { user } } = await supabase.auth.getUser();
            const clienteId = user?.user_metadata?.cliente_id || clienteData?.id;
            if (!clienteId) throw new Error('Cliente ID não encontrado.');

            const senhaHash = formData.senha ? await bcrypt.hash(formData.senha, 10) : null;

            if (usuarioEditando) {
                const { error } = await supabase.rpc('atualizar_usuario_sistema', {
                    p_usuario_id: usuarioEditando.id, p_nome: formData.nome, p_email: formData.email,
                    p_senha: senhaHash, p_perfil: formData.perfil, p_ativo: formData.ativo
                });
                if (error) throw error;
                toast({ title: 'Usuário atualizado', status: 'success', duration: 3000, isClosable: true });
            } else {
                const { error } = await supabase.rpc('criar_usuario_sistema', {
                    p_cliente_id: clienteId, p_nome: formData.nome, p_email: formData.email,
                    p_senha: senhaHash, p_perfil: formData.perfil, p_ativo: formData.ativo
                });
                if (error) throw error;
                toast({ title: 'Usuário criado', status: 'success', duration: 3000, isClosable: true });
            }
            onClose();
            fetchUsuarios();
        } catch (error) {
            let msg = error.message || 'Erro ao salvar.';
            if (msg.includes('já cadastrado') || error.code === '23505') msg = 'Este email já está cadastrado.';
            toast({ title: 'Erro ao salvar', description: msg, status: 'error', duration: 5000, isClosable: true });
        } finally {
            setIsSaving(false);
        }
    };

    const handleRedefinirAcesso = async (u) => {
        if (!window.confirm(`Redefinir acesso de "${u.nome}"?`)) return;
        try {
            const { error } = await supabase.rpc('redefinir_auth_usuario', { p_usuario_id: u.id });
            if (error) throw error;
            toast({ title: 'Acesso redefinido', status: 'success', duration: 4000, isClosable: true });
            fetchUsuarios();
        } catch (error) {
            toast({ title: 'Erro ao redefinir acesso', description: error.message, status: 'error', duration: 5000, isClosable: true });
        }
    };

    const handleExcluirUsuario = async (u) => {
        if (!window.confirm(`Excluir "${u.nome}"?`)) return;
        try {
            const clienteId = session.user.user_metadata?.cliente_id || session.user.app_metadata?.cliente_id || clienteData?.id;
            const { error } = await supabase.from('usuarios_sistema').delete().eq('id', u.id).eq('cliente_id', clienteId);
            if (error) throw error;
            toast({ title: 'Usuário excluído', status: 'info', duration: 3000, isClosable: true });
            fetchUsuarios();
        } catch (error) {
            toast({ title: 'Erro ao excluir', description: error.message, status: 'error', duration: 5000, isClosable: true });
        }
    };

    const handleToggleAtivo = async (u) => {
        try {
            const clienteId = session.user.user_metadata?.cliente_id || session.user.app_metadata?.cliente_id || clienteData?.id;
            const { error } = await supabase.from('usuarios_sistema').update({ ativo: !u.ativo, updated_at: new Date().toISOString() }).eq('id', u.id).eq('cliente_id', clienteId);
            if (error) throw error;
            toast({ title: u.ativo ? 'Usuário desativado' : 'Usuário ativado', status: 'success', duration: 2000, isClosable: true });
            fetchUsuarios();
        } catch (error) {
            toast({ title: 'Erro ao alterar status', description: error.message, status: 'error', duration: 5000, isClosable: true });
        }
    };

    const total = usuarios.length;
    const ativos = usuarios.filter(u => u.ativo).length;
    const inativos = total - ativos;
    const admins = usuarios.filter(u => u.perfil === 'admin').length;

    const inputStyle = {
        width: '100%', padding: '10px 14px', borderRadius: '10px', background: '#f8fafc',
        border: '1px solid #e2e8f0', color: '#1e293b', fontSize: '14px',
        fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box',
    };
    const labelStyle = { display: 'block', fontSize: '12px', fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px' };

    return (
        <>
            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }

                .um-stat-hero { background:rgba(255,255,255,0.18); border:1px solid rgba(255,255,255,0.3); border-radius:16px; padding:18px 22px; backdrop-filter:blur(12px); transition:all 0.2s; }
                .um-stat-hero:hover { background:rgba(255,255,255,0.26); transform:translateY(-2px); }

                .um-table-row { border-bottom:1px solid #f1f5f9; transition:background 0.15s; }
                .um-table-row:hover { background:#f8fafc; }
                .um-table-row:last-child { border-bottom:none; }

                .um-btn-ghost { display:inline-flex; align-items:center; gap:6px; padding:7px 12px; border-radius:8px; font-size:13px; font-weight:500; border:none; cursor:pointer; font-family:inherit; transition:all 0.15s; background:none; color:#94a3b8; }
                .um-btn-ghost:hover { background:#f1f5f9; color:#475569; }
                .um-btn-ghost.warn { color:#ea580c; }
                .um-btn-ghost.warn:hover { background:rgba(234,88,12,0.08); color:#c2410c; }
                .um-btn-ghost.danger { color:#ef4444; }
                .um-btn-ghost.danger:hover { background:rgba(239,68,68,0.08); color:#dc2626; }

                .um-btn-primary { background:rgba(255,255,255,0.22); border:1px solid rgba(255,255,255,0.4); border-radius:10px; color:#fff; font-weight:700; font-size:14px; padding:10px 20px; cursor:pointer; font-family:inherit; transition:all 0.2s; display:inline-flex; align-items:center; gap:8px; backdrop-filter:blur(8px); }
                .um-btn-primary:hover { background:rgba(255,255,255,0.32); transform:translateY(-1px); box-shadow:0 6px 20px rgba(0,0,0,0.15); }
                .um-btn-primary-white { background:linear-gradient(135deg,#2CCB90,#2DB8E1); border:none; border-radius:10px; color:#fff; font-weight:700; font-size:14px; padding:10px 20px; cursor:pointer; font-family:inherit; transition:all 0.2s; display:inline-flex; align-items:center; gap:8px; }
                .um-btn-primary-white:hover { transform:translateY(-1px); box-shadow:0 6px 20px rgba(44,203,144,0.35); }

                .um-input:focus { border-color:#2CCB90 !important; box-shadow:0 0 0 3px rgba(44,203,144,0.1) !important; background:#f0fdf8 !important; }
                .um-input::placeholder { color:#94a3b8; }

                .um-menu-item { display:flex; align-items:center; gap:10px; width:100%; padding:10px 14px; border-radius:10px; font-size:13px; font-weight:500; color:#475569; background:none; border:none; cursor:pointer; font-family:inherit; transition:all 0.15s; text-align:left; }
                .um-menu-item:hover { background:#f1f5f9; color:#0f172a; }
                .um-menu-item.danger { color:#ef4444; }
                .um-menu-item.danger:hover { background:rgba(239,68,68,0.06); color:#dc2626; }

                .um-content-card { background:#ffffff; border:1px solid #e8edf2; border-radius:16px; box-shadow:0 1px 4px rgba(0,0,0,0.05); }

                .um-toggle { width:36px; height:20px; border-radius:10px; border:none; cursor:pointer; transition:all 0.25s; position:relative; flex-shrink:0; }
                .um-toggle-thumb { position:absolute; top:2px; left:2px; width:16px; height:16px; border-radius:50%; background:#fff; transition:transform 0.25s; }

                .um-stats-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:16px; }
                .um-perfis-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:12px; }

                @media (max-width: 900px) { .um-col-hide { display: none !important; } }
                @media (max-width: 700px) {
                    .um-stats-grid { grid-template-columns: repeat(2,1fr); }
                    .um-perfis-grid { grid-template-columns: repeat(2,1fr); }
                }
                @media (max-width: 640px) { .um-nav-email { display: none; } }
            `}</style>

            <div style={{ minHeight:'100vh', background:'#f0f4f8', fontFamily:"'Inter', -apple-system, sans-serif" }}>

                {/* NAVBAR */}
                <header style={{ position:'sticky', top:0, zIndex:50, background:'rgba(255,255,255,0.92)', backdropFilter:'blur(20px)', WebkitBackdropFilter:'blur(20px)', borderBottom:'1px solid #e8edf2' }}>
                    <div style={{ maxWidth:'1280px', margin:'0 auto', padding:'0 24px', height:'64px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:'16px' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:'14px' }}>
                            <div style={{ display:'inline-flex', alignItems:'center', background:'#fff', borderRadius:'10px', padding:'5px 14px', border:'1px solid #e8edf2', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
                                <img src="/logo-horizontal.png" alt="Evlo" style={{ height:'26px', objectFit:'contain' }} onError={e => { e.target.style.display='none'; }} />
                            </div>
                            <button onClick={() => navigate('/')} style={{ display:'flex', alignItems:'center', gap:'6px', padding:'7px 14px', borderRadius:'10px', background:'#f1f5f9', border:'1px solid #e2e8f0', color:'#64748b', fontSize:'13px', fontWeight:500, cursor:'pointer', fontFamily:'inherit', transition:'all 0.15s', whiteSpace:'nowrap' }}
                                onMouseEnter={e => { e.currentTarget.style.background='#e2e8f0'; e.currentTarget.style.color='#0f172a'; }}
                                onMouseLeave={e => { e.currentTarget.style.background='#f1f5f9'; e.currentTarget.style.color='#64748b'; }}
                            >
                                <ArrowLeftIcon /> Voltar ao Início
                            </button>
                            {clienteData && (
                                <span style={{ padding:'4px 12px', borderRadius:'100px', background:'rgba(44,203,144,0.1)', border:'1px solid rgba(44,203,144,0.25)', color:'#16a974', fontSize:'11px', fontWeight:700 }}>
                                    {clienteData.nome}
                                </span>
                            )}
                        </div>

                        <div style={{ position:'relative' }}>
                            <button
                                onClick={(e) => { e.stopPropagation(); setMenuOpen(!menuOpen); }}
                                style={{ display:'flex', alignItems:'center', gap:'10px', padding:'6px 12px', borderRadius:'12px', background: menuOpen ? '#f1f5f9' : '#ffffff', border:'1px solid #e2e8f0', cursor:'pointer', transition:'all 0.15s', fontFamily:'inherit' }}
                            >
                                <div style={{ width:'32px', height:'32px', borderRadius:'50%', background:'linear-gradient(135deg, #2CCB90, #2DB8E1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:700, color:'#fff', flexShrink:0 }}>
                                    {iniciais}
                                </div>
                                <div className="um-nav-email" style={{ textAlign:'left' }}>
                                    <p style={{ margin:0, fontSize:'13px', fontWeight:600, color:'#0f172a' }}>{nomeUsuario}</p>
                                </div>
                                <span style={{ color:'#94a3b8', transition:'transform 0.2s', transform: menuOpen ? 'rotate(180deg)' : 'none' }}><ChevronIcon /></span>
                            </button>

                            {menuOpen && (
                                <div style={{ position:'absolute', top:'calc(100% + 8px)', right:0, minWidth:'200px', background:'#ffffff', border:'1px solid #e2e8f0', borderRadius:'14px', boxShadow:'0 16px 48px rgba(0,0,0,0.1)', padding:'8px', zIndex:100 }}>
                                    <button className="um-menu-item" onClick={() => { navigate('/perfil'); setMenuOpen(false); }}>
                                        <HomeIcon /> Meu Perfil
                                    </button>
                                    <div style={{ height:'1px', background:'#f1f5f9', margin:'6px 0' }} />
                                    <button className="um-menu-item danger" onClick={handleLogout}>
                                        <LogoutIcon /> Sair
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </header>

                {/* HERO com gradiente Evlo */}
                <div style={{ background:'linear-gradient(135deg, #0A1F3A 0%, #0d3d6e 55%, #0891b2 100%)', padding:'36px 24px 56px', position:'relative', overflow:'hidden' }}>
                    {/* Texture sutil */}
                    <div style={{ position:'absolute', inset:0, backgroundImage:'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.08) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.06) 0%, transparent 40%)', pointerEvents:'none' }} />
                    <div style={{ maxWidth:'1280px', margin:'0 auto', position:'relative', zIndex:1 }}>
                        <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:'16px', flexWrap:'wrap', marginBottom:'28px' }}>
                            <div>
                                <p style={{ margin:'0 0 4px', fontSize:'12px', fontWeight:600, color:'rgba(255,255,255,0.7)', textTransform:'uppercase', letterSpacing:'0.1em' }}>Gerenciamento</p>
                                <h1 style={{ margin:'0 0 6px', fontSize:'clamp(24px,4vw,32px)', fontWeight:800, color:'#ffffff', letterSpacing:'-0.03em' }}>Usuários</h1>
                                <p style={{ margin:0, fontSize:'14px', color:'rgba(255,255,255,0.7)' }}>Gerencie os acessos e perfis da equipe</p>
                            </div>
                            <button className="um-btn-primary" onClick={handleNovoUsuario}>
                                <PlusIcon /> Novo Usuário
                            </button>
                        </div>

                        {/* Stats no hero */}
                        <div className="um-stats-grid">
                            {[
                                { label:'Total', value: total, sublabel:'Cadastrados' },
                                { label:'Ativos', value: ativos, sublabel:'Com acesso' },
                                { label:'Inativos', value: inativos, sublabel:'Bloqueados' },
                                { label:'Administradores', value: admins, sublabel:'Acesso total' },
                            ].map(s => (
                                <div key={s.label} className="um-stat-hero">
                                    <p style={{ margin:'0 0 4px', fontSize:'11px', color:'rgba(255,255,255,0.65)', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.07em' }}>{s.label}</p>
                                    <p style={{ margin:'0 0 2px', fontSize:'28px', fontWeight:800, color:'#ffffff', letterSpacing:'-0.02em' }}>{s.value}</p>
                                    <p style={{ margin:0, fontSize:'12px', color:'rgba(255,255,255,0.6)' }}>{s.sublabel}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* CONTEÚDO — sobe sobre o hero */}
                <main style={{ maxWidth:'1280px', margin:'-24px auto 0', padding:'0 24px 80px', position:'relative', zIndex:1 }}>

                    {/* Perfis Info */}
                    <div className="um-content-card" style={{ padding:'20px 24px', marginBottom:'20px' }}>
                        <p style={{ margin:'0 0 14px', fontSize:'13px', fontWeight:600, color:'#64748b', textTransform:'uppercase', letterSpacing:'0.06em' }}>Perfis de Acesso</p>
                        <div className="um-perfis-grid">
                            {PERFIS_ACESSO.map(p => (
                                <div key={p.value} style={{ background:'#f8fafc', border:`1px solid ${p.border}`, borderLeft:`3px solid ${p.color}`, borderRadius:'10px', padding:'12px 14px' }}>
                                    <p style={{ margin:'0 0 4px', fontSize:'13px', fontWeight:700, color: p.color }}>{p.label}</p>
                                    <p style={{ margin:'0 0 6px', fontSize:'11px', color:'#94a3b8' }}>{p.description}</p>
                                    <span style={{ fontSize:'11px', fontWeight:600, color: p.color, background: p.bg, padding:'2px 8px', borderRadius:'100px', border:`1px solid ${p.border}` }}>
                                        {usuarios.filter(u => u.perfil === p.value).length} usuários
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Tabela */}
                    <div className="um-content-card">
                        {isLoading ? (
                            <div style={{ padding:'60px', textAlign:'center' }}>
                                <div style={{ width:'40px', height:'40px', borderRadius:'50%', border:'3px solid rgba(44,203,144,0.2)', borderTopColor:'#2CCB90', animation:'spin 0.8s linear infinite', margin:'0 auto 12px' }} />
                                <p style={{ color:'#94a3b8', fontSize:'14px', margin:0 }}>Carregando...</p>
                            </div>
                        ) : usuarios.length === 0 ? (
                            <div style={{ padding:'60px', textAlign:'center' }}>
                                <div style={{ width:'56px', height:'56px', borderRadius:'16px', background:'#f8fafc', border:'1px solid #e2e8f0', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', color:'#cbd5e1' }}>
                                    <UsersIcon />
                                </div>
                                <p style={{ margin:'0 0 6px', fontSize:'16px', fontWeight:600, color:'#64748b' }}>Nenhum usuário cadastrado</p>
                                <p style={{ margin:'0 0 20px', fontSize:'13px', color:'#94a3b8' }}>Comece adicionando o primeiro usuário</p>
                                <button className="um-btn-primary-white" onClick={handleNovoUsuario}><PlusIcon /> Adicionar Usuário</button>
                            </div>
                        ) : (
                            <div style={{ overflowX:'auto' }}>
                                <table style={{ width:'100%', borderCollapse:'collapse' }}>
                                    <thead>
                                        <tr style={{ borderBottom:'1px solid #f1f5f9' }}>
                                            {['Nome', 'Email', 'Perfil', 'Status', 'Data', 'Ações'].map((h, i) => (
                                                <th key={h} className={i >= 2 && i <= 4 ? 'um-col-hide' : ''} style={{ padding:'14px 20px', textAlign: i === 5 ? 'right' : 'left', fontSize:'11px', fontWeight:700, color:'#94a3b8', textTransform:'uppercase', letterSpacing:'0.07em', whiteSpace:'nowrap' }}>{h}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {usuarios.map(u => {
                                            const pi = getPerfilInfo(u.perfil);
                                            return (
                                                <tr key={u.id} className="um-table-row">
                                                    <td style={{ padding:'14px 20px' }}>
                                                        <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                                                            <div style={{ width:'32px', height:'32px', borderRadius:'50%', background: pi.bg, border:`1px solid ${pi.border}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'11px', fontWeight:700, color: pi.color, flexShrink:0 }}>
                                                                {getInitials(u.nome)}
                                                            </div>
                                                            <span style={{ fontSize:'14px', fontWeight:500, color:'#0f172a' }}>{u.nome}</span>
                                                        </div>
                                                    </td>
                                                    <td style={{ padding:'14px 20px', fontSize:'13px', color:'#64748b' }}>{u.email}</td>
                                                    <td className="um-col-hide" style={{ padding:'14px 20px' }}>
                                                        <span style={{ display:'inline-flex', padding:'3px 10px', borderRadius:'100px', background: pi.bg, border:`1px solid ${pi.border}`, color: pi.color, fontSize:'11px', fontWeight:700, whiteSpace:'nowrap' }}>
                                                            {pi.label}
                                                        </span>
                                                    </td>
                                                    <td className="um-col-hide" style={{ padding:'14px 20px' }}>
                                                        <button onClick={() => handleToggleAtivo(u)} className="um-toggle" style={{ background: u.ativo ? '#2CCB90' : '#e2e8f0' }} title={u.ativo ? 'Desativar' : 'Ativar'}>
                                                            <div className="um-toggle-thumb" style={{ transform: u.ativo ? 'translateX(16px)' : 'translateX(0)' }} />
                                                        </button>
                                                    </td>
                                                    <td className="um-col-hide" style={{ padding:'14px 20px', fontSize:'13px', color:'#94a3b8' }}>
                                                        {new Date(u.created_at).toLocaleDateString('pt-BR')}
                                                    </td>
                                                    <td style={{ padding:'14px 20px', textAlign:'right' }}>
                                                        <div style={{ display:'flex', gap:'4px', justifyContent:'flex-end' }}>
                                                            <button className="um-btn-ghost" onClick={() => handleEditarUsuario(u)} title="Editar"><EditIcon /></button>
                                                            <button className="um-btn-ghost warn" onClick={() => handleRedefinirAcesso(u)} title="Redefinir acesso"><RepeatIcon /></button>
                                                            <button className="um-btn-ghost danger" onClick={() => handleExcluirUsuario(u)} title="Excluir"><DeleteIcon /></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </main>
            </div>

            {/* Modal */}
            <Modal isOpen={isOpen} onClose={onClose} size="md">
                <ModalOverlay bg="rgba(0,0,0,0.4)" backdropFilter="blur(8px)" />
                <ModalContent bg="#ffffff" border="1px solid #e2e8f0" borderRadius="16px" mx={4} boxShadow="0 20px 60px rgba(0,0,0,0.15)">
                    <ModalHeader color="#0f172a" borderBottom="1px solid #e2e8f0" pb={4}>
                        {usuarioEditando ? 'Editar Usuário' : 'Novo Usuário'}
                    </ModalHeader>
                    <ModalCloseButton color="#94a3b8" />
                    <ModalBody py={6}>
                        <div style={{ display:'grid', gap:'16px' }}>
                            {[
                                { label:'Nome Completo', key:'nome', type:'text', placeholder:'Digite o nome completo' },
                                { label:'Email', key:'email', type:'email', placeholder:'email@exemplo.com' },
                            ].map(f => (
                                <div key={f.key}>
                                    <label style={labelStyle}>{f.label}</label>
                                    <input type={f.type} className="um-input" style={inputStyle} placeholder={f.placeholder}
                                        value={formData[f.key]} onChange={e => setFormData({ ...formData, [f.key]: e.target.value })} />
                                </div>
                            ))}

                            <div>
                                <label style={labelStyle}>Senha {usuarioEditando && '(deixe vazio para não alterar)'}</label>
                                <div style={{ position:'relative' }}>
                                    <input type={showSenha ? 'text' : 'password'} className="um-input" style={{ ...inputStyle, paddingRight:'44px' }}
                                        placeholder="Senha segura" value={formData.senha}
                                        onChange={e => setFormData({ ...formData, senha: e.target.value })} />
                                    <button type="button" onClick={() => setShowSenha(!showSenha)}
                                        style={{ position:'absolute', right:'12px', top:'50%', transform:'translateY(-50%)', background:'none', border:'none', color:'#94a3b8', cursor:'pointer', padding:'4px', display:'flex', alignItems:'center' }}>
                                        {showSenha ? <EyeOffIcon /> : <EyeIcon />}
                                    </button>
                                </div>
                            </div>

                            <div>
                                <label style={labelStyle}>Perfil de Acesso</label>
                                <select className="um-input" style={{ ...inputStyle, cursor:'pointer' }}
                                    value={formData.perfil} onChange={e => setFormData({ ...formData, perfil: e.target.value })}>
                                    {PERFIS_ACESSO.map(p => (
                                        <option key={p.value} value={p.value} style={{ background:'#ffffff', color:'#1e293b' }}>
                                            {p.label} — {p.description}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {formData.perfil && (
                                <div style={{ background:'rgba(44,203,144,0.06)', border:'1px solid rgba(44,203,144,0.2)', borderRadius:'10px', padding:'12px 14px' }}>
                                    <p style={{ margin:'0 0 4px', fontSize:'12px', fontWeight:600, color:'#2CCB90' }}>Módulos para {getPerfilInfo(formData.perfil).label}:</p>
                                    <p style={{ margin:0, fontSize:'12px', color:'#64748b' }}>{getPerfilInfo(formData.perfil).modulos.join(', ')}</p>
                                </div>
                            )}

                            <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                                <button
                                    onClick={() => setFormData({ ...formData, ativo: !formData.ativo })}
                                    className="um-toggle"
                                    style={{ background: formData.ativo ? '#2CCB90' : '#e2e8f0' }}
                                >
                                    <div className="um-toggle-thumb" style={{ transform: formData.ativo ? 'translateX(16px)' : 'translateX(0)' }} />
                                </button>
                                <span style={{ fontSize:'13px', color:'#64748b' }}>Usuário {formData.ativo ? 'ativo' : 'inativo'}</span>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter borderTop="1px solid #e2e8f0" gap={3}>
                        <button onClick={onClose} style={{ padding:'9px 18px', borderRadius:'10px', background:'#f8fafc', border:'1px solid #e2e8f0', color:'#64748b', fontSize:'14px', cursor:'pointer', fontFamily:'inherit' }}>
                            Cancelar
                        </button>
                        <button className="um-btn-primary" onClick={handleSalvarUsuario} disabled={isSaving}>
                            {isSaving ? 'Salvando...' : (usuarioEditando ? 'Atualizar' : 'Criar Usuário')}
                        </button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default UsuariosMain;
